import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-slate-900 text-white border-slate-700 shadow-lg",
          description: "text-slate-400",
          actionButton:
            "bg-emerald-500 text-white",
          cancelButton:
            "bg-slate-700 text-white",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
